import { AnalyticEventValue } from '../../../shared/entity_datas/EntityDatas.ts';
import { showBecomeMemberDialog } from '../../shared/scripts/ui_popup/showBecomeMemberDialog.ts';
import { convertChatResponseToText, convertFailedToSendReasonToChatData } from '../../shared/scripts/RoomChatUtils.ts';
import { LobbyImage } from '@colonist/types';
export function registerWebRoomClientHandlers(roomClient, uiManager) {
    roomClient.onRoomStateUpdated((roomState)=>{
        uiManager.room.updateRoom(roomState);
    });
    roomClient.onInfoMessageUpdated((data)=>{
        uiManager.room.center.infoMessageController.setMessage(data);
    });
    roomClient.onSeedOrderSelected((data)=>{
        uiManager.room.updateSeedOrderSelection(data);
    });
    roomClient.onPlayOrderSelected((data)=>{
        uiManager.room.updatePlayOrderSelection(data);
    });
    roomClient.onGotKicked((roomId, canRejoin)=>{
        uiManager.lobby.onGotKicked(roomId, canRejoin);
        uiManager.room.leaveRoom(undefined, undefined, true);
    });
    roomClient.onKickedInactiveHost(()=>{
        uiManager.room.onKickedInactiveHost();
    });
    roomClient.onFailedToStartGameMembershipRequired(()=>{
        showBecomeMemberDialog('gameplay', AnalyticEventValue.RoomPremiumItemPopupBecomeAMemberButton);
    });
    roomClient.onReceivedChatMessage((message, senderUsername, senderIcon)=>{
        uiManager.room.chat.postMessage(message, senderUsername, senderIcon);
    });
    roomClient.onFailedToSendChatMessage((reason, mutedUntil)=>{
        uiManager.room.chat.post({
            text: convertFailedToSendReasonToChatData(reason, mutedUntil),
            icon: LobbyImage.Lightning
        });
    });
    roomClient.onReceivedChatResponse((response)=>{
        for (const responseText of convertChatResponseToText(response)){
            uiManager.room.chat.post({
                text: responseText,
                icon: LobbyImage.Lightning
            });
        }
    });
}
